export interface ManageDataSource {
  isLoading: boolean;
  dataSource: DataSource;
}

export interface DataSource {
  [key: string]: boolean;
}

export enum DataSourceEnum {
  Facebook = "facebook",
  Google = "google",
  Tiktok = "tiktok",
}
